import ReactGA from 'react-ga'
import backendApi from '../api/backendApi';
import { NEW_LOG } from '../constants/queries/logger';
export const GAE_TRACKING_ID = process.env.NEXT_PUBLIC_ENV === 'production' ? 'UA-201298624-1'
  : '';
if(typeof window !== 'undefined'){
  ReactGA.plugin.require("ecommerce");
}

export const initGA = () => {
  ReactGA.plugin.require("ecommerce");
  console.log('GA init')
  // ReactGA.initialize({
  //   trackingId: GAE_TRACKING_ID,
  //   debug: true,
  //   gaOptions: {
  //       cookieDomain: "none"
  //   }
  // });
  // ReactGA.plugin.require('ecommerce');
}
export const logPageView = (url) => {
  console.log(`Logging pageview for ${url}`)
  ReactGA.pageview(url)
}

export const addItem = async (data) => {
  console.log('this is data',data);
  // ReactGA.plugin.execute("ecommerce", "addItem", {
  //   id: data.transaction_id,
  //   name: data.productName,
  //   price: data.price,
  //   quantity: "1"
  // });
  // ReactGA.plugin.execute("ecommerce", "addTransaction", {
  //   id: data.transaction_id,
  //   revenue: data.price,
  //   tax : data.tax,
  //   coupon : data.coupon_code
  // });
  // ReactGA.plugin.execute('ecommerce', 'send');
  // ReactGA.plugin.execute('ecommerce', 'clear');


  // window.dataLayer = window.dataLayer || [];
  // window.dataLayer.push({
  // transactionId:  data.transaction_id,
  // transactionAffiliation: 'Online Store',
  // transactionTotal: data.price, 
  // transactionTax:data.tax,
  // transactionProducts: [{
  //   sku: data.productName,
  //   name: data.productName,
  //   // category: 'Apparel',
  //   price: data.price,  
  //   quantity: 1 
  // }]
  // });


  // if(window.dataLayer){
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event : 'purchase',
      ecommerce: {
        purchase: {
          actionField: {
            id: data.transaction_id,                         // Transaction ID. Required for purchases and refunds.
            affiliation: 'Online Store',
            revenue: data.price,                     // Total transaction value (incl. tax and shipping)
            tax: data.tax,
            coupon : data.coupon_code
          },
          products: [{                            // List of productFieldObjects.
            name: data.productName,     // Name or ID is required.
            id: data.productId,
            price: data.price,
            quantity: 1,
            coupon: data.coupon_code                           // Optional fields may be omitted or set to empty string.
          }]
        }
      }
    });
  // }

}
export const addTransaction = async (data) => {
  ReactGA.plugin.execute("ecommerce", "addTransaction", {
    id: data.transaction_id,
    revenue: data.price
  });
  ReactGA.plugin.execute('ecommerce', 'send');
  ReactGA.plugin.execute('ecommerce', 'clear');

  // await backendApi.post('/', {
  //   query: NEW_LOG,
  //   variables: {
  //     mobile: "Google Analytics",
  //     info: 'addTransaction',
  //     context: `add Transaction with id = ${data.transaction_id}  and revenue= ${data.price}`
  //   },
  // });
}
